(() => {
  if (window.__vcp) return; window.__vcp = true;
  const init = () => {
    const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { threshold: .12 }) : null;
    document.querySelectorAll('.vcp-reveal').forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));

    document.querySelectorAll('[data-vcp-gallery]').forEach((g) => {
      const main = g.querySelector('[data-vcp-main]');
      g.querySelectorAll('[data-vcp-thumb]').forEach((b) => b.addEventListener('click', () => {
        main.src = b.dataset.src; main.srcset = ''; main.alt = b.dataset.alt || '';
        g.querySelectorAll('[data-vcp-thumb]').forEach((x) => x.setAttribute('aria-current', x === b));
      }));
    });

    // Barra fija de compra (celular): visible desde que carga la página,
    // salvo mientras el botón principal está en pantalla.
    const sticky = document.querySelector('.vcp-sticky');
    const anchor = document.querySelector('[data-vcp-buy-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting))
        .observe(anchor);
    } else if (sticky) {
      sticky.classList.add('is-on');
    }
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
